import React from 'react';
import Hash from "object-hash";
import { Tbody, Thead, Tr } from "react-super-responsive-table";
import FeatherIconWrapper from "../../Icons/FeatherIconWrapper";
import { WerfenColor } from "../../../Constants/ColorChart";
import SortAsc from "../../Icons/Sort/SortAsc";
import SortDesc from "../../Icons/Sort/SortDesc";
import ResultRow from "./ResultRow/ResultRow";
import { DateWrapper, HeaderTitle, StyledTable, TableHeader } from "./ResultTableStyled/ResultTableStyled";
import useWindowDimensions from "../../Sensors/useWindowDimensions";



export const ResultTableUnified = (props) => {
    const { downloadRequest, fieldsToShow, data, type, sortData, createdSortOrder, updatedSortOrder, dataToSort, client, setSelectedForDownload, sendPlaylistDownloadRequest, userSalesOrgs, userRoles, defaultAction, showPointer, tableUnified } = props;
    const { windowWidth } = useWindowDimensions ();
    const tabletFormat=  windowWidth < 1050 && windowWidth > 992;
    const mobileFormat = (  ( navigator.userAgent.indexOf ( 'IEMobile' ) !== -1 )  || ( windowWidth < 992 ) );
    let fieldCreated = 'created';
    let fieldUpdated = 'updated';
    if (process.env.REACT_APP_SEE_DATES === "1") {
      fieldCreated = 'last synced';
      fieldUpdated = 'valid from';
    }

    return ( <StyledTable key={ Hash ( JSON.stringify ( data ) ) }><Thead>
    <Tr>
    { fieldsToShow && fieldsToShow.map ( ( fieldToShow, index ) => {
        //Loop to render all fields that we want to show
        if ( fieldToShow === "type" ) {
            return (
                <TableHeader key={ "type" }>
                    <HeaderTitle tabletFormat={ tabletFormat} />
                </TableHeader>
            )
        } else if ( fieldToShow === "size" && windowWidth < 1050 ) {
            return null
        } else if (fieldToShow === "created" && windowWidth < 768 ) {
            return null;
        }else if (fieldToShow === "created" ){
            return (
                <TableHeader
                    key={ Hash ( fieldToShow + index ) }
                >
                    <DateWrapper
                        tabletFormat= { tabletFormat }
                        mobileFormat={ mobileFormat }
                    >
                        <HeaderTitle tabletFormat = { tabletFormat }>{ fieldCreated }</HeaderTitle>
                        {createdSortOrder === "asc" && <FeatherIconWrapper
                            className={ "SortAsc top-bar-icon" }
                            id={fieldToShow + "Asc"}
                            color={ WerfenColor }
                            width="30px"
                            role={"button"}
                            ariaLabel={fieldToShow}
                            onClick={ (e)=>sortData(e, fieldToShow)}
                            iconStyle="stroke-width: 1.3px; &:hover{cursor: pointer}"
                            Icon={  SortAsc }
                        />}
                        {createdSortOrder === "desc" &&<FeatherIconWrapper
                            id={fieldToShow + "Desc"}
                            className={ "SortDesc top-bar-icon" }
                            color={ WerfenColor }
                            width="30px"
                            role={"button"}
                            ariaLabel={fieldToShow}
                            onClick={ (e)=>sortData(e, fieldToShow)}
                            iconStyle="stroke-width: 1.3px; &:hover{cursor: pointer}"
                            Icon={  SortDesc }
                        />}

                    </DateWrapper>


                </TableHeader>
            )
        }  else if (fieldToShow === "updated" && windowWidth < 768 ) {
            return null;
        } else if (fieldToShow === "updated") {
            return (

                <TableHeader
                    key={ Hash ( fieldToShow + index ) }
                >
                    <DateWrapper  tabletFormat={ tabletFormat }
                                  mobileFormat={ mobileFormat }
                    >
                        <HeaderTitle tabletFormat={ tabletFormat }>{ fieldUpdated }</HeaderTitle>
                        { updatedSortOrder === "asc" && <FeatherIconWrapper
                            id={ fieldToShow + "Asc" }
                            role={"button"}
                            ariaLabel={ fieldToShow }
                            className={ "SortAsc top-bar-icon" }
                            color={ WerfenColor }
                            width="30px"
                            onClick={ ( e ) => sortData ( e, fieldToShow ) }
                            iconStyle="stroke-width: 1.3px; &:hover{cursor: pointer}"
                            Icon={ SortAsc }

                        /> }
                        { updatedSortOrder === "desc" && <FeatherIconWrapper
                            id={ fieldToShow + "Desc" }
                            role={"button"}
                            ariaLabel={ fieldToShow }
                            className={ "SortDesc top-bar-icon" }
                            color={ WerfenColor }
                            width="30px"
                            onClick={ ( e ) => sortData ( e, fieldToShow ) }
                            iconStyle="stroke-width: 1.3px; &:hover{cursor: pointer}"
                            Icon={ SortDesc }
                        /> }
                    </DateWrapper>
                </TableHeader>
            )
        } else {
            return (
                <TableHeader
                    key={ Hash ( fieldToShow + index ) }
                >
                    <HeaderTitle tabletFormat={ tabletFormat} >{ fieldToShow === "language" ? "lang." : fieldToShow === "mimetype" ? "type" : fieldToShow }</HeaderTitle>
                </TableHeader> )
        }
    } ) }
    <TableHeader key={ "actions" }><HeaderTitle tabletFormat={ tabletFormat} /></TableHeader>
</Tr>
</Thead>
    <Tbody>
        { data.length > 1 ?
            dataToSort.map ( ( row, index ) => {
                //Loop into the objects
                let rowId = `${ row.metadata.entityBundle }_${ row.id }`;
                if ( row.metadata.entityBundle === undefined && row.id === undefined ) {
                    rowId = type + "_" + index;
                }
                return <ResultRow
                    fieldsToShow={ fieldsToShow }
                    row={ row }
                    sapFile={ row.metadata && row.metadata.entityBundle && row.metadata.entityBundle === "sap_file" }
                    bokeccVideo={ row.metadata && row.metadata.entityBundle && row.metadata.entityBundle === "bokecc_video" }
                    externalLink={ row.metadata && row.metadata.entityBundle && row.metadata.entityBundle === "external_link" }
                    rowId={ rowId }
                    key={ rowId }
                    defaultAction={ defaultAction ? defaultAction : null }
                    showPointer={ showPointer }
                    index={ index }
                    type={ type }
                    tableUnified={ tableUnified }
                    apolloClient={ client }
                    setSelectedForDownload={ setSelectedForDownload }
                    requestIncludesMe={ downloadRequest.includes ( row.uuid ) }
                    sendPlaylistDownloadRequest={ sendPlaylistDownloadRequest }
                    userSalesOrgs={ userSalesOrgs }
                    userRoles={ userRoles }
                />
            } )
            :
            <ResultRow
                fieldsToShow={ fieldsToShow }
                row={ data }
                sapFile={ data.metadata && data.metadata.entityBundle && data.metadata.entityBundle === "sap_file" }
                bokeccVideo={ data.metadata && data.metadata.entityBundle && data.metadata.entityBundle === "bokecc_video" }
                externalLink={ data.metadata && data.metadata.entityBundle && data.metadata.entityBundle === "external_link" }
                rowId={ data.metadata && data.metadata.entityBundle ? `${ data.metadata.entityBundle }_${ data.id }` : `${ data.type }_${ data.id }` }
                key={ type + "_" + data.id }
                defaultAction={ defaultAction ? defaultAction : null }
                showPointer={ showPointer }
                index={ 0 }
                type={ type }
                tableUnified={ tableUnified }
                apolloClient={ client }
                setSelectedForDownload={ setSelectedForDownload }
                requestIncludesMe={ downloadRequest.includes ( data.uuid ) }
                sendPlaylistDownloadRequest={ sendPlaylistDownloadRequest }
                userSalesOrgs={ userSalesOrgs }
                userRoles={ userRoles }
            />
        }
    </Tbody>
</StyledTable>
    )
}
